import PageCourse from './PageCourse';

export default PageCourse;
export { default as PageCoursePropTypes } from './PageCoursePropTypes';
